module.exports = __webpack_public_path__ + "static/media/valor-declarado.63210c73.png";